import PropTypes from 'prop-types';

import { Badge } from '#/modules/commonComponents/badge';
import { labelOf } from '#/modules/crmMgmt/customerOrder/helper/collection';

const POSITIVE = new Set(['APPROVED', 'CONFIRMED', 'VERIFIED']);
const WARNING = new Set(['NEEDS_REAPPROVAL', 'PARTIAL', 'UNKNOWN']);
const NEGATIVE = new Set(['VOIDED', 'SUPERSEDED', 'PAYMENT_VOID', 'REFUND', 'REFUND_VOID']);

const CollectionStatusBadge = ({ status, labels }) => {
  if (!status) {
    return '—';
  }
  let className = 'bg-slate-100 text-slate-700';
  if (POSITIVE.has(status)) {
    className = 'bg-emerald-100 text-emerald-800';
  } else if (WARNING.has(status)) {
    className = 'bg-amber-100 text-amber-800';
  } else if (NEGATIVE.has(status)) {
    className = 'bg-rose-100 text-rose-800';
  }
  return (
    <Badge variant="secondary" className={className}>
      {labelOf(labels, status)}
    </Badge>
  );
};

CollectionStatusBadge.propTypes = {
  status: PropTypes.string,
  labels: PropTypes.object.isRequired,
};

export default CollectionStatusBadge;
